module.exports = __webpack_public_path__ + "img/logo.d7d7ee2d.png";